import { UiKitDialogBase } from '@/fo/ui/kit/dialog/base';

import { ImagesCarousel, ThumbnailsCarousel } from '../components';
import { useLightbox } from '../hooks/useLightbox';
import { LightboxImage } from '../types';

import { styles } from './UiReviewLightboxBase.styles';

export interface UiReviewLightboxBaseProps {
  open?: boolean;
  images: LightboxImage[];
  onOpenChange?: (open: boolean) => void;
  selectedIndex?: number | null;
  title: string;
  trigger?: React.ReactNode;
  onOpenReview?: (reviewId: string) => void;
}

export function UiReviewLightboxBase({
  open,
  images,
  onOpenChange,
  title,
  trigger,
  onOpenReview,
  ...props
}: UiReviewLightboxBaseProps) {
  const slots = styles();

  const {
    emblaMainRef,
    emblaThumbsRef,
    emblaMainApi,
    selectedIndex,
    onThumbClick,
    prevBtnDisabled,
    nextBtnDisabled
  } = useLightbox({ selectedIndex: props.selectedIndex });

  return (
    <UiKitDialogBase
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      trigger={trigger}
      className={slots.dialogContent()}
      fullScreen
    >
      <div className={slots.base()}>
        <ImagesCarousel
          images={images}
          emblaRef={emblaMainRef}
          emblaApi={emblaMainApi}
          className={slots.imagesCarousel()}
          selectedIndex={selectedIndex}
          onOpenReview={onOpenReview}
        />
        <ThumbnailsCarousel
          images={images}
          selectedIndex={selectedIndex}
          onThumbClick={onThumbClick}
          emblaRef={emblaThumbsRef}
          emblaMainApi={emblaMainApi}
          className={slots.thumbnailsCarousel()}
          prevBtnDisabled={prevBtnDisabled}
          nextBtnDisabled={nextBtnDisabled}
        />
      </div>
    </UiKitDialogBase>
  );
}
